import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "./home.css";

const Home = () => {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="home-page">
      {showSplash && (
        <div id="splash-screen">
          <img
            src="/assets/foxhead.png"
            alt="ScanTAPS Mascot"
            id="splash-logo"
          />
        </div>
      )}

      <Header buttons={[{ to: "/help", label: "Help" }]} />

      <main className="content">
        <div className="logo">
          <img src="/assets/logo.png" alt="ScanTaps Logo" />
        </div>

        <div className="buttons">
          <Link to="/login">
            <button className="login">Login</button>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
